module.exports = __webpack_public_path__ + "img/ring_r_0_1_0@3x.dd2d0acd.png";